/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */
import styled from "styled-components";
import { FlexContainer, theme } from "@nordcloud/gnui";

export const ColoredBar = styled.div`
  width: 100%;
  height: ${theme.spacing.spacing03};
  border-radius: ${theme.radius.md};
  background-image: linear-gradient(
    to right,
    ${theme.color.interactive.errorHover},
    ${theme.color.background.warning},
    ${theme.color.interactive.successHover}
  );
  position: relative;
  margin-bottom: ${theme.spacing.spacing06};
`;

export const SectionsContainer = styled(FlexContainer)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

export const Section = styled.div`
  width: 25%;
  height: ${theme.spacing.spacing03};
  box-sizing: border-box;
  position: relative;

  &:not(:last-child) {
    border-right: 1px solid ${theme.color.background.ui01};
  }
`;

type IndicatorProps = {
  marginLeft: number;
};

export const Indicator = styled.div<IndicatorProps>`
  margin-top: -${theme.spacing.spacing01};
  width: ${theme.spacing.spacing01};
  height: ${theme.spacing.spacing05};
  background-color: ${theme.color.text.text01};
  border-radius: ${theme.radius.sm};

  margin-left: ${({ marginLeft }) => marginLeft}%;
`;

type PercentageLabelProps = {
  lastSection: boolean;
};

export const PercentageLabel = styled.span<PercentageLabelProps>`
  position: absolute;
  right: 0;
  bottom: -1.75rem;
  font-size: ${theme.fontSizes.sm};
  color: ${theme.color.text.text02};

  transform: ${({ lastSection }) =>
    lastSection ? "unset" : "translateX(50%)"};
`;

export const SectionLabel = styled.span`
  position: absolute;
  left: 50%;
  bottom: -1.6rem;
  font-size: ${theme.fontSizes.sm};
  font-weight: ${theme.fontWeights.medium};
  transform: translateX(-50%);
`;
